import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { router, AppRoute } from '@/lib/router';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Auth0回调页面
 * 专门处理Auth0的重定向回调，避免与登录页面冲突
 */
export const AuthCallbackPage: React.FC = () => {
  const { isLoading, error, isAuthenticated } = useAuth0();
  const { isAuthenticated: isAppAuthenticated } = useAuth();

  useEffect(() => {
    // 如果Auth0处理完成且没有错误
    if (!isLoading && !error) {
      if (isAuthenticated) {
        // Auth0认证成功，等待应用处理社交登录
        // useSocialAuth hook会自动处理后续的社交登录流程
        console.log('Auth0 callback processed, waiting for app authentication...');
      } else {
        // Auth0认证失败或取消，重定向到登录页
        console.log('Auth0 authentication failed or cancelled, redirecting to login...');
        router.navigate(AppRoute.LOGIN);
      }
    }
  }, [isLoading, error, isAuthenticated]);

  // 当应用认证成功后，重定向到主页
  useEffect(() => {
    if (isAppAuthenticated) {
      console.log('App authentication successful, redirecting to home...');
      router.navigate(AppRoute.HOME);
    }
  }, [isAppAuthenticated]);

  // 如果有错误，显示错误信息并提供返回登录的选项
  if (error) {
    return (
      <div className="flex min-h-svh flex-col items-center justify-center bg-muted/40 p-6 md:p-10">
        <div className="w-full max-w-sm text-center">
          <div className="mb-6">
            <h2 className="text-xl font-semibold text-red-600 mb-2">
              Authentication Error
            </h2>
            <p className="text-gray-600 mb-4">
              {error.message || 'An error occurred during authentication.'}
            </p>
            <button
              onClick={() => router.navigate(AppRoute.LOGIN)}
              className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors"
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  // 显示加载状态
  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-muted/40 p-6 md:p-10">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-muted-foreground">Processing authentication...</p>
      </div>
    </div>
  );
};
